
      <div class="alert alert-success" *ngIf="alertSuccess">
        Email Updated successfully!
      </div>
      <div class="alert alert-danger" *ngIf="alertFailure">
        {{errorMsg}} !
     </div>
      <div class="alert alert-danger" *ngIf= "noUser">
        No user found !
      </div>
      <div class="alert alert-success" *ngIf="userFound">
        Please select from user dropdown
        </div>
      <div class="alert alert-danger" *ngIf="alertError">
       Something went wrong !!!
      </div>
      <div class="alert alert-danger" *ngIf="timeOutError">
        {{timeoutErrorMessage}}
      </div>	

  
  <div class="col-sm-12 col-md-12 col-xl-12">
    <div class="col-md-12 col-xs-12 col-sm-12 heading p-l-5 mt-5 mb-4">
      <span class="span-create-edit-hoshin color pl-5">EMAIL MANAGEMENT</span>
      <span class="pt-1" style="font-size: 13px;"><a href="assets/userguides/EmailManagementUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
    </div>
    <br><br>

    <form (ngSubmit)="onSubmit()" name="form" #myForm="ngForm">
      <div class="mainSection"> 
        <div  *ngIf = "(adminId == 1 || adminId == 2 || adminId == 3 || isbpgAdmin || isbpgLeadAdmin)" >    
          <label for="selectUsers" class="searchlabelName">Select Users <span class="star"> *</span></label><span  class="colon">:</span>
          <div class = "selectDropSet">
            <ng-select id="selectUsers" placeholder ="Select User" name = "userName"  class="custom" [items] = "userList" bindLabel ="userFirstName" bindValue="userId" [(ngModel)]="userFirstName" (change)="userSelection($event)" (keyup)="findbyEmail($event)" required >
              <ng-template ng-option-tmp let-item="item" let-index="index">
                <div>{{item.userFirstName}}</div>
                <div *ngIf="item.division" style="font-size: 11px">{{item.division}}</div>
                <div *ngIf="item.classification" style="font-size: 11px">{{item.classification}}</div>
              </ng-template>
          </ng-select> 
        </div>
</div>
       
        <label class="searchlabelName">Name</label><span class="colon">:</span><span class="datas">{{name}}</span>
     
        <div *ngIf = "!emailflag" >
          <label class="searchlabelName"  >Email Id</label><span class="colon">:</span><span class="datas" >{{email}}</span>
 
        </div>
       
        <div *ngIf ="emailflag">
          <label class="searchlabelName" >Email Id<span class="star">*</span></label><span class="colon-email">:</span><span ><input type="email" class="form-control width-class-email" placeholder="Enter Personal Email Address" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"   
            required name="email"  ngModel
            #email="ngModel" id="email"></span>
            <div class="validation-error-message" *ngIf="email.errors?.pattern">Please enter  a valid Email Address</div> 
         
        </div> 
      
        <div>
          <label class="searchlabelName">Workday Id</label><span  class="colon">:</span><span class="datas">{{workId}}</span>
        </div>
      <div>
          <label class="searchlabelName">Division</label><span  class="colon">:</span><span class="datas">{{division}}</span>
        </div>
        <div>
          <label class="searchlabelName">Site</label><span  class="colon">:</span><span class="datas">{{site}}</span>
        </div> 
      </div>
    
      <div class="btn-div">
        <button type="submit" class="btn btn-danger"  [disabled]="!emailflag || !myForm.valid || email.invalid"    data-toggle="modal" data-target="#myModal">UPDATE</button>
        <button type="button" class="btn btn-danger" (click)="resetClick()" data-toggle="modal" data-target="#myModal">RESET</button>
      </div>
  
    </form>
  <br>
  <app-confirmation-modal [PData]="msg1" (emitPass)="this[method](param)" id="1"></app-confirmation-modal>
